import { Team } from '../../types'

/**
 * Minimum required team members for a valid team
 */
export const MIN_TEAM_MEMBERS = 3

/**
 * Helper function to create empty team slots
 */
export const createEmptyTeamSlots = (team: Team) => {
  return Array.from({ length: team.maxParticipants - team.participants.length }, (_, index) => ({
    key: `empty-${index}`
  }))
}

/**
 * Helper function to check if team has insufficient members
 */
export const hasInsufficientTeamMembers = (team: Team): boolean => {
  return team.participants.length < MIN_TEAM_MEMBERS
}

/**
 * Helper function to get team member count display
 */
export const getTeamMemberCount = (team: Team): string => {
  return `${team.participants.length}/${team.maxParticipants}`
}

/**
 * Helper function to calculate how many more members are needed to meet minimum
 */
export const getSlotsNeededForMinimum = (team: Team): number => {
  return Math.max(0, MIN_TEAM_MEMBERS - team.participants.length)
}
